// extracted by mini-css-extract-plugin
export default {"qr-code":"QrCode_qr-code__77Bxl","qr-info":"QrCode_qr-info__Duu-W"};